import { Box, Divider } from "@mui/material";

import styled from "styled-components";

import { isSmallDesktop } from "@/hooks/layout";

/**
 * `$isSection` is the seam between two full-bleed sections — the same line as the
 * one the hero and "How it works" meet on (`HomeTrustBox`), which is authored
 * there because the stats card has to sit centred on top of it. Keep the two
 * identical: 1px, fading out at both edges. Everything else (header, footer,
 * the Music Creator page) keeps the heavier opaque rule.
 */
export const StyledDivider = styled(Divider)<{
  $isFooter?: boolean;
  $isPage?: boolean;
  $isHeader?: boolean;
  $isSection?: boolean;
}>`
  width: 100%;
  height: ${({ $isSection }) => ($isSection ? "1px" : "2px")};
  z-index: 0;
  position: absolute;
  bottom: ${({ $isFooter }) => ($isFooter ? "unset" : 0)};
  top: ${({ $isFooter }) => ($isFooter ? 0 : "unset")};

  ${({ $isSection }) =>
    $isSection
      ? `
    border: none;
    background: linear-gradient(
      to right,
      transparent,
      rgba(255, 210, 155, 0.5) 22%,
      rgba(255, 210, 155, 0.5) 78%,
      transparent
    );
  `
      : `
    background: linear-gradient(
      93deg,
      rgba(186, 144, 92, 0.5) 0.82%,
      #ffd29b 33.73%,
      #ffe0b1 47.65%,
      #ffd29b 61.53%,
      rgba(186, 144, 92, 0.5) 99.48%
    );
  `}
`;

export const VerticalConnector = styled(Box)`
  height: 40px;
  min-height: 40px;
  width: 50%;

  align-self: flex-start;

  border: 2px solid;
  border-image-slice: 1;

  border-left: 0;
  border-bottom: 0;
  border-top: 0;

  border-image-source: linear-gradient(
    0deg,
    rgba(253, 209, 154, 1) 0%,
    rgba(255, 210, 155, 1) 40%,
    rgba(255, 224, 177, 1) 50%,
    rgba(255, 210, 155, 1) 60%,
    rgba(186, 144, 92, 1) 100%
  );

  ${isSmallDesktop} {
    height: 56px;
  }
`;
